/*eslint no-control-regex: "off"*/
// Helper Functions for Validation

// TPIA Registration Form
export function registrationTpiaValidation(data) {
    if (
        data.firstName === "" ||
        data.lastName === "" ||
        data.firmId.includes("") ||
        data.crdList.includes("")
    ) {
        return "All fields are required";
    }
    if (!emailVerifyMatch(data.email, data.verifyEmail)) {
        return "Email addresses do not match";
    } else if (!emailValidation(data.email)) {
        return "Please enter valid email address";
    } else if (data.id === "") {
        return "Please create user name";
    } else if (!userNameValidation(data.id)) {
        return "Please enter valid user name";
    }
    return true;
}

// My Teams Registration Form
export function myTeamsRegistrationValidation(data) {
    if (
        data.firstName === "" ||
        data.lastName === "" ||
        data.fpFirstName === "" ||
        data.fpLastName === ""
    ) {
        return "All fields are required";
    }
    if (!emailVerifyMatch(data.email, data.verifyEmail)) {
        return "Email addresses do not match";
    } else if (!emailValidation(data.email)) {
        return "Please enter valid email address";
    } else if (data.id === "") {
        return "Please create user name";
    } else if (!userNameValidation(data.id)) {
        return "Please enter valid user name";
    }
    return true;
}

// Email
export function emailValidation(email) {
    const expression = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return expression.test(String(email).toLowerCase());
}

// UserName
export function userNameValidation(userName) {
    const expression = /^[A-Za-z0-9]{6,8}$/;
    return expression.test(String(userName));
}

// Email - Verify Match
export function emailVerifyMatch(email, verifyEmail) {
    return email.toLowerCase() === verifyEmail.toLowerCase();
}

// SSN (123-45-6789)
export function ssnValidation(ssn) {
    if (ssn === undefined) {
        return false;
    } else {
        const expression = /^\d{3}-?\d{2}-?\d{4}$/;
        return expression.test(String(ssn).toLowerCase());
    }
}

// TIN (12-3456789)
export function tinValidation(tin) {
    if (tin === undefined) {
        return false;
    } else {
        const expression = /^\d{2}-?\d{7}$/;
        return expression.test(String(tin).toLowerCase());
    }
}
